module.exports = __webpack_public_path__ + "img/olympic-rugby.0bfa11cf.png";